import { observable, action, runInAction } from "mobx";
import { Etapa, Orcamento } from "../../../../services";
import { error, success, info } from "../../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../../utils/Validate";

class EtapaStore {
  @observable
  etapa = {
    codigo: "",
    nome: "",
    itens: []
  };

  @observable
  item = {
    codigo: "",
    nome: ""
  };

  @observable
  modal = false;

  @observable
  orcamento = {};

  @observable
  etapas = [];

  @observable
  fetching = false;

  toggle = () => {
    this.modal = !this.modal;
  };

  reset = () => {
    this.etapa = {
      nome: "",
      codigo: `${this.etapas.length + 1}`,
      itens: []
    };

    this.item = {
      codigo: "",
      nome: ""
    };
  };

  @action.bound
  async obterOrcamento(id) {
    try {
      this.fetching = true;

      const result = await Orcamento.buscar(id);
      if (result && result.erro) {
        return error(result.erro);
      }

      this.orcamento = result;
      this.etapas = [].concat(this.orcamento.etapas);
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;
    this.etapa[name] = value;
  };

  iniciarCadastroEtapa = () => {
    this.reset();
    this.toggle();
  };

  @action.bound
  async salvar() {
    try {
      this.fetching = true;

      const erros = this.validarCadastroEtapa(this.etapa);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Etapa.cadastrar(this.toEtapa());
      if (result.erro) {
        error(result.erro);
        return;
      }

      runInAction(() => {
        this.etapas.push(this.etapa);
        this.toggle();
      });

      success(`Etapa ${this.etapa.codigo} cadastrada com sucesso!`);
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async excluir(etapa) {
    try {
      this.fetching = true;

      const result = await Etapa.excluir(etapa.id);
      if (result.erro) {
        error(result.erro);
        return;
      }

      runInAction(() => {
        this.etapas.remove(etapa);
      });

      info("Etapa excluída com sucesso!");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  iniciarEdicaoEtapa = etapa => {
    this.etapa = etapa;

    this.toggle();
  };

  @action.bound
  async alterar() {
    try {
      this.fetching = true;

      const erros = this.validarCadastroEtapa(this.etapa);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Etapa.alterar(this.toEtapa());
      if (result.erro) {
        error(result.erro);
        return;
      }

      runInAction(() => {
        const busca = this.etapas.find(e => e.id === this.etapa.id);
        busca.nome = this.etapa.nome;
        busca.itens = this.etapa.itens;
      });

      success(`Etapa '${result.nome}' alterada com sucesso!`);
      this.toggle();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleBlurItem = ({ target }) => {
    const { name, value } = target;

    const item = this.etapa.itens.find(item => name === `item.${item.codigo}`);
    if (item && value) {
      item.nome = value;
    }
  };

  @action.bound
  handleChangeItem = ({ target }) => {
    const { name, value } = target;
    this.item[name] = value;
  };

  toEtapa() {
    const novo = {
      ...this.etapa,
      codigo: parseInt(this.etapa.codigo, 0),
      orcamentoId: parseInt(this.orcamento.id, 0)
    };

    return novo;
  }

  validarCadastroEtapa = etapa => {
    const validar = validarCamposObrigatorios()
      .addSeNuloOuVazio("Código", etapa.codigo)
      .addSeNuloOuVazio("Nome", etapa.nome)
      .addSeNuloOuVazio("Itens", etapa.itens);

    const verfica = this.etapas.find(q => q.codigo === etapa.codigo);
    if (verfica && verfica.id !== etapa.id) {
      validar.addMensagem(`Já existe uma etapa com este código(${etapa.nome})!`);
    }

    return validar.build();
  };

  @action.bound
  incluirNovoItemEtapa = () => {
    if (!this.item.nome) {
      error("O campo 'Nome do Item' não pode ser vazio!");
      return;
    }

    const codigo = this.etapa.codigo;
    const id = this.etapa.id ? this.etapa.id : codigo;
    this.item = {
      nome: this.item.nome,
      etapaOrcamentoId: parseInt(id, 0),
      codigo: String(codigo)
        .concat(".")
        .concat(this.etapa.itens.length + 1)
    };

    runInAction(() => {
      this.etapa.itens.push(this.item);
    });
  };

  @action.bound
  excluirItemEtapa(item) {
    this.etapa.itens.remove(item);

    const codigo = this.etapa.codigo;
    this.etapa.itens = this.etapa.itens.map((item, i) => ({
      ...item,
      codigo: `${codigo}.${i + 1}`
    }));
  }
}

export default new EtapaStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/orcamentos/stores/EtapaStore.js